import { render, staticRenderFns } from "./CardRanking.vue?vue&type=template&id=6be944f5&scoped=true&"
import script from "./CardRanking.vue?vue&type=script&lang=js&"
export * from "./CardRanking.vue?vue&type=script&lang=js&"
import style0 from "./CardRanking.vue?vue&type=style&index=0&id=6be944f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be944f5",
  null
  
)

export default component.exports